<template>
  <b-container>
    <div v-if="!stripeConnectAuthResponse.status">{{ $t('StripeConnectResponse.processing') }}</div>
    <b-row v-else-if="stripeConnectAuthResponse.status === 'success'" class="mt-3 justify-content-center">
        <b-alert show variant="success" class="text-center">
          <h3>{{ $t('StripeConnectResponse.success') }} <font-awesome-icon icon="check-circle" /></h3>
          <p>{{stripeConnectAuthResponse.msg}}</p>
        </b-alert>
      </b-row>
      <b-row v-else class="mt-3 justify-content-center">
        <b-alert show variant="danger" class="text-center">
          <h3>{{ $t('StripeConnectResponse.error') }} <font-awesome-icon icon="times-circle" /></h3>
          <p>{{stripeConnectAuthResponse.msg}}</p>
        </b-alert>
      </b-row>

      <b-row v-if="stripeConnectAuthResponse.status" class="justify-content-center">
        <router-link :to="{name: 'Home'}">{{ $t('StripeConnectResponse.homeLink') }}</router-link>
      </b-row>

  </b-container>
</template>
<script>
import StripeConnectService from '@/services/StripeConnectService'
import { mapGetters } from 'vuex'
export default {
  name: 'StripeConnectResponse',
  data () {
    return {
      stripeConnectAuthResponse: {
        status: null,
        msg: null
      }
    }
  },
  mounted () {
    // redirect to home if stripeConnectUserId is already set
    if (this.stripeConnectUserId) {
      this.$router.push({ name: 'Home' })
    }

    this.getUrlQueryParams()
  },
  methods: {
    getUrlQueryParams () {
      if (this.$route.query.error) {
        this.stripeConnectAuthResponse.status = 'error'
        this.stripeConnectAuthResponse.msg = this.$i18n.t('StripeConnectResponse.serverMessages.stripeConnectionDeniedMsg')
      } else if (this.$route.query.code) {
        this.getStripeConnectClientAuth(this.$route.query.code)
      }
    },
    async getStripeConnectClientAuth (code) {
      let creds = {
        code: code,
        _id: this.user._id
      }
      try {
        let response = await StripeConnectService.authorize(creds)
        if (response.data.status === 'success') {
        // set User state
          this.$store.dispatch('setStripeConnectUserId', response.data.stripeUserId)
        }
        this.stripeConnectAuthResponse.status = response.data.status
        this.stripeConnectAuthResponse.msg = response.data.msg
      } catch (err) {
        console.log(err)
        this.stripeConnectAuthResponse.status = 'error'
        this.stripeConnectAuthResponse.msg = this.$i18n.t('StripeConnectResponse.serverMessages.stripeConnectionErrorMsg')
      }
    }
  },
  computed: {
    ...mapGetters({ user: 'user', stripeConnectUserId: 'stripeConnectUserId' })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StripeConnectResponse.vue